import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "className"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Banner = props => {
  var {
      keyname = 'banner',
      name,
      className
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var key = keyname || name;
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    name: key,
    className: "login-page3-banner " + (className || '')
  }));
};
Banner.displayName = 'Login.Banner';